import { prefixer, createApiConsts } from '../../../../Helpers/constants'

export const METADATA_TYPE = {
  DATE: 'DATE',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  HYPERLINK: 'HYPERLINK',
}

const createPrefixedConst = prefixer('METADATA_EDITOR')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const SAVE_METADATA = createPrefixedApiConsts('SAVE_METADATA')
export const SAVE_METADATUM = createPrefixedApiConsts('SAVE_METADATUM')
